import { priceFormatter } from '@noths/polaris-client-utils';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

export const getFormattedPrice = (amount: number, currencyCode: CurrencyCode) => {
  return amount === 0 ? 'FREE' : priceFormatter(currencyCode, amount, false);
};
